'use client';

import { useRegistryContext } from '../../../../context/RegistryProvider';

export interface WalkthroughStepContentProps {
  rootBlockId: string | null | undefined;
}

/**
 * WalkthroughStepContent - Renders step content blocks.
 * Device and display-type agnostic component that renders blocks using the registry.
 */
export function WalkthroughStepContent({ rootBlockId }: WalkthroughStepContentProps) {
  const { registry } = useRegistryContext();
  const BlockRenderer = registry.getBlockRenderer();

  return <BlockRenderer blockId={rootBlockId ?? null} parentBlockId={null} />;
}
